import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { getIsSiriusEnabled } from '@app/common/sirius-util';
import { PL_API_CONFIG } from '../tokens';
import { ApiUser, PlAPIConfig } from '../models';

@Injectable()
export class PlAuthService {
  private readonly baseUrl: string;

  private readonly baseV2Url: string;

  private readonly loginUrl: string;

  constructor(
    @Inject(PL_API_CONFIG) config: PlAPIConfig,
    private http: HttpClient
  ) {
    this.baseUrl = `${config.auth}/api/v1`;
    this.baseV2Url = `${config.auth}/api/v2`;
    this.loginUrl = `${config.login_url}/api/v1`;
  }

  getUser(): Observable<any> {
    const url = `${this.baseV2Url}/users/me/`;
    return this.http.get(url);
  }

  getUserStatus(
    lastActive?: number
  ): Observable<{ user: ApiUser; token: string }> {
    let url;
    if (getIsSiriusEnabled()) {
      url = `${this.baseUrl}/status/`;
    } else {
      url = `${this.loginUrl}/status/`;
    }

    let params: any = {};
    if (typeof lastActive !== 'undefined') {
      params = { ...params, lastActive };
    }
    return this.http.get<{ user: ApiUser; token: string }>(url, {
      params,
      withCredentials: true,
    });
  }
}
